interface IPushAddToCartAdditionalPackageEventProps {
  category: string;
  name: string;
}

export function pushAddToCartAdditionalPackageEvent({
  category,
  name,
}: IPushAddToCartAdditionalPackageEventProps) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        addToCart: {
          actionField: {
            step: 1,
            action: "addToCart",
          },
        },
        products: [
          {
            name,
            brand: "nju",
            category,
            variant: "Unknown",
            quantity: 1,
            price: 0,
          },
        ],
      },
      pageType: "eshop",
    });
  }
}
